export const normalize = `
  html {
    userSelect: none,
  }
  #root {
    height: 100vh
  }
`;
